// i18n
import './locales/i18n';

// highlight
import './utils/highlight';

// scroll bar
import 'simplebar/src/simplebar.css';

// lightbox
import 'react-image-lightbox/style.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';
import './utils/mapboxgl';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';
// @mui
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
// redux
import { persistor, store } from './redux/store';
// contexts
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { SettingsProvider } from './contexts/SettingsContext';

// Check our docs
// https://docs-minimals.vercel.app/authentication/ts-version

import { AuthProvider } from './contexts/JWTContext';
// import { AuthProvider } from './contexts/Auth0Context';
// import { AuthProvider } from './contexts/FirebaseContext';
// import { AuthProvider } from './contexts/AwsCognitoContext';

//
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { registerLicense } from '@syncfusion/ej2-base';

// ----------------------------------------------------------------------

registerLicense(
  'ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxWdkBgWX9ddHBWQGVYWEF9XUI='
);

//  'Mgo+DSMBaFt/QHFqVVhlVFpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF9jTn5Xd0ZmW3tfc3JdTg==;Mgo+DSMBPh8sVXJ0S0d+XE9BflRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3xTcUVnWHxbcnBURWhdWQ==;ORg4AjUWIQA/Gnt2VVhhQlFac1dJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJjXX5ddXZRR2NVUkw=;NjY4MjU5QDMyMzAyZTMxMmUzMGZ4SzhGbTdRbnhwc014Q25LT0VWYVAraGtpbS9EY3FtUjdJS1I0TXU5TFE9;NjY4MjYwQDMyMzAyZTMxMmUzMGNTVzdBNG5LOGhTRDFDSXdzS3czdVZnL05XQzZTbDJmdnJ3VU1RNi9sdVU9;NRAiBiAaIQQuGjN/V0Z+XU9EaFpKVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdEVkWXtfc3FXQmFYVEJ+;NjY4MjYyQDMyMzAyZTMxMmUzMEhBdHRDUm9KSG4vVk5TY0R5M2JHUlpiWjAvK0tmRGtxSHpRS0ZBU21ob1U9;NjY4MjYzQDMyMzAyZTMxMmUzMFpKMlhSNFYwb2tQTHJ4bWNuVjRkZC9kNm4yZHlkWjd5aHIzcXJHSTJCVGM9;Mgo+DSMBMAY9C3t2VVhhQlFac1dJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJjXX5ddXZRR2VdVkw=;NjY4MjY1QDMyMzAyZTMxMmUzME5wR2Y4dC8xVi84d1FaVGQyWG9xRG1Bc1d0V1JpbWFUQUJUUE95VzJHYW89;NjY4MjY2QDMyMzAyZTMxMmUzMFk0bXhrZXBLaHU1QXNxTWx3NlJhVzh6djY2YSsyckZMNlBvWnEvUThna0E9'

ReactDOM.render(
  <AuthProvider>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <CollapseDrawerProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </CollapseDrawerProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  </AuthProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
